export const PROMOS_AND_REWARDS_CONSTANT = {
  URL: '/images/offers/lg/',
  PNG: '.png',
  DEFAULT_IMAGE_PATH: '/images/items/no-image.jpg',
  VIEW_DETAIL_IMAGE_PATH: '/images/offers/detail/',
  PROMOS_CARD_IMAGE_PATH: '/images/offers/card/',
  CONTENT_DATA_MAX_LENGTH_TO_SCROLL: 4,
  CONTENT_DATA_MAX_LENGTH_TO_SHOW: 9,
  TIME_IN_MILLISECONDS: 1000,

  CAROUSAL_CONFIG: {
    SPEED: 200,
    SLIDES_TO_SHOW: 3,
    SLIDES_TO_SCROLL: 1,
  },
  BUTTON_TEXT: {
    VIEW_DETAILS: 'viewdetails',
    REDEEM: 'redeem',
  },
  OFFERS_HEADER_TEXT: {
    OFFERS_AND_DEALS: 'offerDeals',
    VIEW_ALL_DEALS: 'viewAllDeal',
  },
  FADE_CARD_INDEX: 3,
  DEFAULT_PAGE_SIZE: 6,
  SILCK_RESPONSIVE_PROPERTY: [
    {
      breakpoint: 1950,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1720,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
      },
    },
  ],
};
